import React, { useState } from 'react';
import * as styles from './TemplateTag.module.css';

export const TemplateTag = ({ file }) => {
  if (process.env.NODE_ENV !== 'development') return null;
  return <DevTemplateTag file={file} />;
};

const DevTemplateTag = ({ file }) => {
  const [copied, setCopied] = useState(false);

  const copy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(file);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
    } catch {
      // ignore — clipboard can fail outside a secure context
    }
  };

  return (
    <div className={styles.tag} title={file}>
      <span className={styles.label}>template</span>
      {file}
      <button
        type="button"
        className={styles.copy}
        onClick={copy}
        aria-label={copied ? 'Copied filename' : 'Copy filename'}
      >
        {copied ? (
          'copied'
        ) : (
          <svg viewBox="0 0 16 16" width="10" height="10" aria-hidden="true">
            <path
              fill="currentColor"
              d="M6 2h7a1 1 0 0 1 1 1v8h-1.5V3.5H6V2zm-3 3h7a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm.5 1.5v7h6v-7h-6z"
            />
          </svg>
        )}
      </button>
    </div>
  );
};
